import {Timestamp} from '@wandb/weave/components/Timestamp';
import React from 'react';

import {useUpdateArtifactCollectionMutation} from '../../../generated/graphql';
import {Analytics} from '../../../services/analytics';
import {LinkProject} from '../LinkProject';
import {MarkdownEditor} from './MarkdownEditor';
import * as MS from './MetadataValue.styles';
import * as S from './TabMetadata.styles';
import {JobDetails} from './utilTypes';

type TabMetadataProps = {
  entityName: string;
  projectName: string;
  job: JobDetails;
  isDescriptionHighlighted: boolean;
};

export const TabMetadata = ({
  entityName,
  projectName,
  job,
  isDescriptionHighlighted,
}: TabMetadataProps) => {
  const [updateArtifactCollection] = useUpdateArtifactCollectionMutation();

  const onUpdateDescription = (value: string) => {
    updateArtifactCollection({
      variables: {
        artifactSequenceID: job.id,
        description: value,
      },
    });
    Analytics.track('edit artifact description', {
      jobId: job?.id,
      entityName,
      location: 'tab metadata',
    });
  };

  const {description, createdAt, projectAccess} = job;

  const descriptionEditor = (
    <MarkdownEditor
      content={description}
      onSave={onUpdateDescription}
      placeholder="What makes this job special?"
    />
  );

  return (
    <S.MetadataTable>
      <S.Tr>
        <S.Property>Description</S.Property>
        {isDescriptionHighlighted ? (
          <S.HighlightedDescription>
            {descriptionEditor}
          </S.HighlightedDescription>
        ) : (
          <S.Description>{descriptionEditor}</S.Description>
        )}
      </S.Tr>
      <S.Tr>
        <S.Property>Owner entity</S.Property>
        <MS.MainPanel>
          <MS.ContentPanel>{entityName}</MS.ContentPanel>
        </MS.MainPanel>
      </S.Tr>
      <S.Tr>
        <S.Property>Parent project</S.Property>
        <MS.MainPanel>
          <MS.ContentPanel>
            <LinkProject
              entityName={entityName}
              projectName={projectName}
              access={projectAccess}
            />
          </MS.ContentPanel>
        </MS.MainPanel>
      </S.Tr>
      <S.Tr>
        <S.Property>Creation date</S.Property>
        <MS.MainPanel>
          <MS.ContentPanel>
            <Timestamp value={createdAt} />
          </MS.ContentPanel>
        </MS.MainPanel>
      </S.Tr>
    </S.MetadataTable>
  );
};
